import { BillingInterval, PlanType } from "./types";

const url = "/api/v1/subscriptions";

// ref: https://stripe.com/docs/billing/subscriptions/overview#payment-status
export type StripePaymentIntentStatus =
  | "succeeded"
  | "requires_payment_method"
  | "requires_action";

export interface SubscriptionsCreateParams {
  billingInterval: BillingInterval;
  isResubscribe: boolean;
  plan: PlanType;
  promotionCodeId: string;
  redirectStatus: StripePaymentIntentStatus;
}

export interface SubscriptionsCreateResponse {
  stripeCustomerId: string;
}

export interface SubscriptionsUpdateParams {
  billingInterval: BillingInterval;
  plan: PlanType;
  redirectStatus: StripePaymentIntentStatus;
}

export const subscriptionsCreateQuery = (
  params: SubscriptionsCreateParams,
) => ({
  url,
  method: "POST",
  body: params,
});

export const subscriptionsDestroyQuery = () => ({
  url,
  method: "DELETE",
});

export const subscriptionsUpdateQuery = (
  params: SubscriptionsUpdateParams,
) => ({
  url,
  method: "PATCH",
  body: params,
});

export const subscriptionsPauseQuery = () => ({
  url: `${url}/pause`,
  method: "POST",
});

export const subscriptionsResumeQuery = () => ({
  url: `${url}/resume`,
  method: "POST",
});
